export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-battery-full-8ec5263c3d7f6333260014a35b58d09a.svg";